module.exports = __webpack_public_path__ + "static/media/vhc_logo.2416ffca.png";